<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="page_title">问诊记录（已完成）</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div style="border-bottom:1px solid #e8e9f0">
        </div>
        <div
          style="padding: 0 24px 0 24px"
          class="big"
        >
          <div class="searchbox">
            <div class="item">
              <span>患者姓名</span>
              <el-input
                placeholder="请输入"
                v-model="patient_name"
                style="width: 120px; margin-left: 10px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>医生姓名</span>
              <el-input
                placeholder="请输入"
                v-model="doctor_name"
                style="width: 120px; margin-left: 10px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>医生手机号</span>
              <el-input
                placeholder="请输入"
                v-model="doctor_phone"
                style="width: 120px; margin-left: 10px"
                clearable
                @input="search"
              ></el-input>
            </div>
            <div class="item">
              <span>所在省市</span>
              <el-select
                v-model="province_id"
                placeholder="请选择"
                @change="search"
                style="width: 140px; margin-left: 10px"
                clearable
              >
                <el-option
                  v-for="item in proList"
                  :key="item.province_id"
                  :label="item.name"
                  :value="item.province_id"
                ></el-option>
              </el-select>
            </div>

            <div class="item">
              <span>问诊类型</span>
              <el-select
                v-model="consult_type"
                placeholder="请选择"
                style="width: 120px; margin-left: 10px"
                clearable
                @change="search"
              >
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <span style="margin-right: 10px">是否已推送</span>
              <el-radio-group
                v-model="health_bool"
                @change="search"
              >
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </div>

            <div class="item">
              <el-button
                type="primary"
                size="small"
                @click="batchPush"
                :disabled="module_id_array[0] ? !module_id_array.includes('796') : false"
              >批量推送</el-button>
            </div>
          </div>
          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection"></el-table-column>

              <el-table-column
                label="问诊开始时间"
                prop="agree_time"
                width="110px"
              ></el-table-column>

              <el-table-column
                label="问诊费用"
                prop="pay_money"
                width="90px"
              ></el-table-column>

              <el-table-column
                label="患者信息"
                width="140px"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.real_name }}</div>
                  <div>
                    <span v-if="scope.row.patient_sex == 1">男</span>
                    <span v-if="scope.row.patient_sex == 2">女</span>
                    <span style="margin-left: 10px">{{ scope.row.age }}</span>
                  </div>
                  <div>{{ scope.row.id_card }}</div>
                </template>
              </el-table-column>

              <el-table-column
                label="科室"
                prop="department_name"
              ></el-table-column>
              <el-table-column
                label="医生信息"
                width="140px"
              >
                <template slot-scope="scope">
                  <div
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor:pointer"
                  >{{ scope.row.doctor_name }}</div>
                  <div>
                    <span v-if="scope.row.doctor_sex == 1">男</span>
                    <span v-if="scope.row.doctor_sex == 2">女</span>
                    <span style="margin-left: 10px">{{ scope.row.title }}</span>
                  </div>
                  <div>{{ scope.row.phone }}</div>
                </template>
              </el-table-column>

              <el-table-column
                prop="province_name"
                label="所在省市"
              ></el-table-column>

              <el-table-column
                label="结束时间"
                prop="over_time"
              ></el-table-column>

              <el-table-column label="结束类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.status | statusText }}</span>
                </template>
              </el-table-column>

              <el-table-column label="问诊类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.consult_type | consultTypeText }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="是否已推送"
                width="100px"
              >
                <template slot-scope="scope">
                  <span>{{scope.row.health_id > 0 ? '是' : '否'}}</span>
                </template>
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="toDetail(scope.row.consult_id,scope.row.consult_types)"
                    :disabled="module_id_array[0] ? !module_id_array.includes('806') : false"
                  >查看记录</el-button>
                  <el-button
                    type="text"
                    @click="onePush(scope.row)"
                    :disabled="module_id_array[0] ? !module_id_array.includes('796') : false"
                  >推送</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 24px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from '../../../api/platform';
import yewu from '../../../api/yewu';
import DocMsg from '../../../components/common/DocMsg.vue';
import pushWeijianwei from '../../../api/pushWeijianwei';
export default {
  data() {
    return {
      activeIndex: '0',
      totalNum: 0,
      patient_name: '',
      doctor_name: '',
      doctor_phone: '',
      currentPage: 1,
      pagesize: 10,
      consult_type: '',
      tableData: [],
      pre_type: [],
      province_id: '',
      proList: [],
      options2: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '患者问诊'
        },
        {
          value: 2,
          label: '医生赠送'
        },
        {
          value: 3,
          label: '诊后咨询'
        },
        {
          value: 4,
          label: '视频问诊'
        },
        {
          value: 5,
          label: '电话问诊'
        }
      ],
      health_bool: 0,
      selection: [],
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  filters: {
    preGroupText(val) {
      switch (val) {
        case 0:
          return '养生方';
        case -1:
          return '成药';
      }
    },
    statusText(val) {
      switch (val) {
        case 1:
          return '待提问';
        case 2:
          return '待确认';
        case 3:
          return '咨询中';
        case 4:
          return '拒绝接诊';
        case 5:
          return '问诊时间结束';
        case 6:
          return '超时未接诊';
        case 7:
          return '手动结束';
        case 8:
          return '超时未发起';
        case 9:
          return '医生退款';
      }
    },
    consultTypeText(val) {
      switch (val) {
        case 1:
          return '患者问诊';
        case 2:
          return '医生赠送';
        case 3:
          return '诊后咨询';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getProvince();
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取处方列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        patient_name: this.patient_name,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        patient_id: 0,
        is_test: 2,
        consult_status: 2,
        consult_type: this.consult_type,
        province_id: this.province_id,
        health_bool: this.health_bool
      };
      yewu.consultList(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.agree_time = platform.timestampToTime(item.agree_time);
            item.over_time = platform.timestampToTime(item.over_time);
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //多选
    handleSelectionChange(val) {
      let data = val.filter((item) => {
        return item.health_id === 0;
      });
      this.selection = data.map((item) => {
        return item.consult_id;
      });
    },
    //获取省市列表
    getProvince() {
      this.axios
        .post('platform/platform/getProvinceCityDistrict')
        .then((res) => {
          this.proList = res.data.list;
        });
    },
    //查看详情
    toDetail(consult_id, consult_types) {
      this.$router.push({
        path: '/home/yewu/wenzhendetail',
        query: {
          consult_id,
          consult_types,
          isPush: 1
        }
      });
    },
    //发药
    toOrderDetail(order_id) {
      this.$router.push({
        path: '/home/order/orderdetail',
        query: {
          order_id
        }
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    // 批量推送
    batchPush() {
      if (!this.selection.length) {
        this.$message.warning('请选择未推送的处方');
        return;
      }
      let params = {
        consult_id: this.selection.join(',')
      };
      this.onePush(params);
    },
    // 单条推送
    onePush(row) {
      if (row.health_id > 0) {
        this.$message.warning('请选择未推送的处方');
        return;
      }
      pushWeijianwei
        .uploadConsul({ consult_id: row.consult_id })
        .then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success('推送成功');
            this.getList();
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 205px);
  padding-bottom: 20px;
}
.noneline {
  border: 0;
  padding: 0 20px;
}
.title {
  font-size: 16px;
  width: 90px;
}

.mydivider {
  margin: 0;
}

.btnbox {
  text-align: left;
  margin: 20px 0;
  padding-left: 14px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
  .item {
    margin-right: 30px;
    margin-top: 16px;
  }
}
</style>
